import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { CommonModule } from '@angular/common';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-bary-collapse',
  standalone: true,
  imports: [CommonModule, MDBBootstrapModulesPro, BaryIconComponent],
  templateUrl: './bary-collapse.component.html',
  styleUrls: ['./bary-collapse.component.scss'],
})
export class BaryCollapseComponent {
  @Input() label = 'SET_LABEL';
  @Input() withArrow = true;
  @Input() isCollapsed = true;

  @Output() collapseEvent = new EventEmitter<any>();

  protected readonly FAS = FaDirectiveEnum.FAS;
}
